const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./', false, /\.svg$/)
// 加载目录下的所有的 svg 文件
requireAll(req)
